import { useMemo } from 'react';
import { RecordingHostError } from '../types/ErrorTypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const useMediaPlayerErrorMessage = ({
  isError,
  errorType,
  onReload,
  recordingUrl
}) => {
  return useMemo(() => {
    if (!isError) return null;
    if (errorType === RecordingHostError.INSECURE_HOST) {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: {
          Link
        },
        options: {
          href: recordingUrl,
          external: true
        },
        message: "recordingReviewComponents.media.mediaPlayer.errorOverlay.descriptionInsecureHostWithLink_jsx"
      });
    } else if (errorType === RecordingHostError.NO_URL) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "recordingReviewComponents.media.mediaPlayer.errorOverlay.descriptionNoUrl"
      });
    } else if (errorType === RecordingHostError.ZOOM_RECORDING_NOT_FOUND) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "recordingReviewComponents.media.mediaPlayer.errorOverlay.descriptionZoomRecordingNotFound"
      });
    } else if (!onReload) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "recordingReviewComponents.media.mediaPlayer.errorOverlay.title"
      });
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "recordingReviewComponents.media.mediaPlayer.errorOverlay.description"
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onReload,
        use: "tertiary",
        size: "xs",
        marginInlineStart: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "recordingReviewComponents.media.mediaPlayer.errorOverlay.cta"
        })
      })]
    });
  }, [errorType, isError, onReload, recordingUrl]);
};